require("!!/home/selvam/projects/compare-my-religion/frontend/node_modules/script-loader/addScript.js")(require("!!/home/selvam/projects/compare-my-religion/frontend/node_modules/raw-loader/index.js!/home/selvam/projects/compare-my-religion/frontend/node_modules/easy-pie-chart/dist/jquery.easypiechart.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/easy-pie-chart/dist/jquery.easypiechart.js
// module id = 388
// module chunks = 12